import React from 'react'
import { Box, Field, Flex, Input, Select } from '@workwhile/ui'
import { useChargesContextValue } from '../context/ChargesProvider'
import { CompanyPicker } from './CompanyPicker'

const invoicedOptions = [
  { label: 'All', value: 'all' },
  { label: 'Invoiced', value: 'true' },
  { label: 'Uninvoiced', value: 'false' },
] as const

function parseOptionalId(raw: string): number | undefined {
  const trimmed = raw.trim()
  if (trimmed === '') {
    return undefined
  }
  const parsed = Number(trimmed)
  if (!Number.isInteger(parsed) || parsed <= 0) {
    return undefined
  }
  return parsed
}

export const ChargesFilters = () => {
  const {
    state: { companyId, shiftId, workerId, invoiceId, invoiced },
    actions: {
      setCompanyId,
      setShiftId,
      setWorkerId,
      setInvoiceId,
      setInvoiced,
    },
  } = useChargesContextValue()

  const invoicedValue =
    invoiced === null
      ? invoicedOptions[0]
      : invoiced
        ? invoicedOptions[1]
        : invoicedOptions[2]

  return (
    <Flex
      gap={3}
      mb={3}
      flexDirection={['column', 'column', 'row']}
      alignItems={['stretch', 'stretch', 'flex-end']}
      flexWrap="wrap"
    >
      <Box flex={1} minWidth={220}>
        <CompanyPicker value={companyId} onChange={setCompanyId} />
      </Box>
      <Box width={[1, 1, 140]}>
        <Field label="Shift ID">
          <Input
            block
            type="number"
            min={1}
            placeholder="e.g. 123"
            value={shiftId ?? ''}
            onChange={(event) => {
              setShiftId(parseOptionalId(event.target.value))
            }}
          />
        </Field>
      </Box>
      <Box width={[1, 1, 140]}>
        <Field label="Worker ID">
          <Input
            block
            type="number"
            min={1}
            placeholder="e.g. 789"
            value={workerId ?? ''}
            onChange={(event) => {
              setWorkerId(parseOptionalId(event.target.value))
            }}
          />
        </Field>
      </Box>
      <Box width={[1, 1, 140]}>
        <Field label="Invoice ID">
          <Input
            block
            type="number"
            min={1}
            placeholder="e.g. 101"
            value={invoiceId ?? ''}
            onChange={(event) => {
              setInvoiceId(parseOptionalId(event.target.value))
            }}
          />
        </Field>
      </Box>
      <Box width={[1, 1, 180]}>
        <Field label="Invoiced">
          <Select
            block
            options={[...invoicedOptions]}
            value={invoicedValue}
            onChange={(option) => {
              if (option == null || option.value === 'all') {
                setInvoiced(null)
                return
              }
              setInvoiced(option.value === 'true')
            }}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 10011,
                pointerEvents: 'auto',
              }),
            }}
          />
        </Field>
      </Box>
    </Flex>
  )
}
